export default "__VITE_ASSET__BovE9pgn__"